import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import { Button, Grid, Typography, Avatar } from "@mui/material";
import { TextField } from "formik-mui";
import { useNavigate, Link } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { useAuth } from "@poseidon/ui/components/AuthContext";

export const ForgotPassword = () => {
  let navigate = useNavigate();
  let { passwordReset } = useAuth();
  let [error, setError] = useState();

  return (
    <>
      <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Reset password
      </Typography>
      <Formik
        initialValues={{
          email: "",
        }}
        onSubmit={async (values) => {
          try {
            await passwordReset(values.email);
            navigate("/auth/login", {
              state: {
                message: "Recovery email sent, please check your inbox",
              },
            });
          } catch (error) {
            setError(error.code);
          }
        }}
      >
        {({ errors, touched }) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              width: "100%",
            }}
          >
            <Field
              component={TextField}
              name="email"
              label="Email"
              margin="normal"
              autoFocus
              autoComplete="email"
              fullWidth
              required
              type="email"
              id="email"
              helperText={errors.email && "Email required"}
              error={errors.email && touched.email ? true : false}
            />
            {error && (
              <Typography mb={1} color="error">
                {error}
              </Typography>
            )}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              fullWidth
              margin="normal"
              sx={{ mt: 3, mb: 2 }}
            >
              Send Recovery Email
            </Button>
          </Form>
        )}
      </Formik>
      <Grid container>
        <Grid item xs>
          <Link to="/auth/login">
            <Typography variant="body2" color="text.secondary">
              Back to login
            </Typography>
          </Link>
        </Grid>
      </Grid>
    </>
  );
};
